/** What a reader is for. A STAFF_CLOCK reader clocks a staff member in or out and never opens anything. */
export const READER_PURPOSES = ['DOOR', 'STAFF_CLOCK'] as const;
export type ReaderPurpose = (typeof READER_PURPOSES)[number];

export const TIMESHEET_SOURCES = ['MANUAL', 'CLOCK'] as const;
export type TimesheetSource = (typeof TIMESHEET_SOURCES)[number];

/** How a clock entry nobody clocked out of was settled: closed at the planned shift's end, or left for a manager to end. */
export const MISSED_CLOCK_OUTS = ['SHIFT_END', 'FLAGGED'] as const;
export type MissedClockOut = (typeof MISSED_CLOCK_OUTS)[number];

export const CLOCK_ACTIONS = ['IN', 'OUT'] as const;
export type ClockAction = (typeof CLOCK_ACTIONS)[number];
